import { OverflowMenuHorizontal } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

const RowActionsAndExport = () => {
  return (
    <div className="flex items-center gap-2">
      <Button variant="text" size="small" aria-label="More actions" disabled>
        <OverflowMenuHorizontal />
      </Button>
    </div>
  );
};

export default RowActionsAndExport;
